/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { FormikValues, useFormik } from 'formik'
import {
  DefaultStatus,
  TypedFormikConfig,
  TypedFormikHelpers,
  TypedFormikReturn,
} from './types'

/**
 * A hook that wraps Formik's useFormik with proper typing for status
 */
function useTypedFormik<Values extends FormikValues, Status = DefaultStatus>({
  onSubmit,
  ...props
}: TypedFormikConfig<Values, Status>): TypedFormikReturn<Values, Status> {
  const formik = useFormik<Values>({
    ...props,
    onSubmit: (values, helpers) => {
      const typedHelpers: TypedFormikHelpers<Values, Status> = helpers
      return onSubmit(values, typedHelpers)
    },
  })
  const typedFormik: TypedFormikReturn<Values, Status> = {
    ...formik,
    status: formik.status,
  }
  return typedFormik
}

export default useTypedFormik
